export function getBrowserWidth() { // Export required for Mocha testing
  return document.body.offsetWidth;
}
